import { render, staticRenderFns } from "./Photo.vue?vue&type=template&id=425ece34&scoped=true&"
import script from "./Photo.vue?vue&type=script&lang=ts&"
export * from "./Photo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425ece34",
  null
  
)

export default component.exports